/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.purchase.motions.rpc.PurchaseMotionsPublicEvaluationService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const evaluatePublicRpc = {
  serviceName: 'com.hubspot.purchase.motions.rpc.PurchaseMotionsPublicEvaluationService',
  rpcName: 'evaluatePublic',
  auth: 'external',
  fingerprint: 'dGpchXhk94DfvjBVnAwcMJwP6LXzGzX8'
};